import { EXTERNAL_DATA_LAKE_QUERY_TYPE } from 'data-lake/preview/Constants';

export const EXTERNAL_DATA_LAKE_STORAGE_TYPE = 'EXTERNAL';

export const AWS_SECURITY_DATA_LAKE_QUERY = {
  type: EXTERNAL_DATA_LAKE_QUERY_TYPE,
  query_string: '',
} as const;
